import { Customer } from './getCustomer'
import request, { BASE_URL } from './request'

export const addPoints = async (telegramId: string): Promise<Customer> =>
  request({
    method: 'POST',
    url: `${BASE_URL}/customers/add_points/${telegramId}`,
  })
